import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.home');
import { AfterViewInit, ChangeDetectorRef, ElementRef, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Terminal } from '@xterm/xterm';
import { FitAddon } from '@xterm/addon-fit';
import { WebLinksAddon } from '@xterm/addon-web-links';
import { io } from 'socket.io-client';

type LayoutMode = 'single' | 'double' | 'triple' | 'tabs';
type SessionStatus = 'connecting' | 'connected' | 'disconnected' | 'error';
type SocketMode = 'app' | 'ide';

interface ServerPreset {
    id: string;
    name: string;
    hostAlias: string;
    sshUser: string;
    workdir: string;
    color: string;
}

interface TerminalSession {
    id: string;
    roomId: string;
    title: string;
    sequence: number;
    presetId: string;
    hostAlias: string;
    sshUser: string;
    workdir: string;
    status: SessionStatus;
    startedAt: Date;
    lastActiveAt: Date;
    outputBuffer: string[];
    commandBuffer: string;
    closing: boolean;
    initializing: boolean;
    initMarker: string;
    initOutput: string;
    remoteHost?: string;
    socketMode?: SocketMode;
    socket?: any;
    terminal?: Terminal;
    fit?: FitAddon;
    hostElement?: HTMLElement;
}

@Component({
    selector: 'wiz-page-home',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.home/view.scss */
:host {
  display: block;
  width: 100%;
  height: 100vh;
  min-height: 720px;
  background: #07090b;
  color: #d8e5e1;
  overflow: hidden;
}

* {
  box-sizing: border-box;
}

button {
  font: inherit;
}

.workspace-shell {
  height: 100vh;
  min-height: 720px;
  display: grid;
  grid-template-columns: 244px minmax(0, 1fr) 226px;
  overflow: hidden;
  background: #07090b;
}

.preset-sidebar,
.command-dock {
  min-height: 0;
  background: #0d1113;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 18px;
  border-color: #20292c;
}

.preset-sidebar {
  border-right: 1px solid #20292c;
}

.command-dock {
  border-left: 1px solid #20292c;
  overflow: auto;
}

.brand-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding-bottom: 2px;
}

.brand-mark {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: grid;
  place-items: center;
  background: #16f2b3;
  color: #07100d;
  font-weight: 900;
  box-shadow: 0 0 0 1px #5fffd0 inset;
}

.brand-row h1,
.workspace-title h2,
.current-context h3 {
  margin: 0;
}

.brand-row h1 {
  font-size: 18px;
  color: #f4fbf9;
}

.brand-row p,
.workspace-title p,
.terminal-meta small,
.session-pill small,
.current-context p {
  margin: 0;
  color: #7f918c;
  font-size: 12px;
}

.block-title {
  font-size: 12px;
  font-weight: 800;
  color: #8ca09a;
  text-transform: uppercase;
  margin-bottom: 9px;
}

.sidebar-block,
.dock-block {
  min-width: 0;
}

.preset-item,
.session-pill {
  width: 100%;
  border: 1px solid #202a2d;
  background: #12181a;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 10px;
  text-align: left;
  color: #dbe9e4;
}

.preset-item {
  padding: 12px 10px;
  margin-bottom: 9px;
  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.03) inset;
}

.preset-item:hover,
.session-pill:hover {
  border-color: #2f4545;
  background: #151f20;
}

.preset-item.active,
.session-pill.active,
.session-tabs button.active {
  border-color: #16f2b3;
  background: #102420;
  color: #ecfffa;
  box-shadow: 0 0 0 1px rgba(22, 242, 179, 0.22) inset;
}

.preset-dot {
  width: 8px;
  height: 34px;
  border-radius: 99px;
  flex: 0 0 auto;
  box-shadow: 0 0 18px currentColor;
}

.preset-copy {
  display: flex;
  min-width: 0;
  flex: 1;
  flex-direction: column;
  gap: 3px;
}

.preset-copy strong,
.session-name,
.terminal-meta strong {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.preset-copy small {
  color: #8a9a95;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.preset-lock {
  color: #37e7b8;
}

.session-list {
  min-height: 0;
  overflow: auto;
}

.session-pill {
  padding: 9px 10px;
  margin-bottom: 7px;
}

.session-name {
  flex: 1;
}

.security-strip {
  margin-top: auto;
  display: grid;
  gap: 8px;
  color: #7f918c;
  font-size: 12px;
}

.security-strip span {
  display: flex;
  gap: 8px;
  align-items: center;
}

.security-strip i {
  color: #36d7aa;
}

.workspace-main {
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: #090d0f;
}

.topbar {
  height: 68px;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 12px 16px;
  background: #0f1417;
  border-bottom: 1px solid #20292c;
}

.workspace-title h2 {
  font-size: 18px;
  color: #f3fbf8;
}

.status-summary,
.top-actions,
.segmented,
.terminal-tools {
  display: flex;
  align-items: center;
  gap: 8px;
}

.status-summary span {
  font-size: 12px;
  color: #8ca09a;
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

.icon-button,
.primary-button {
  height: 34px;
  border: 1px solid #273437;
  background: #151b1e;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  color: #dce8e4;
}

.icon-button {
  width: 34px;
}

.icon-button:hover {
  border-color: #3b5554;
  background: #1a2426;
}

.icon-button.active {
  background: #16f2b3;
  color: #05100d;
  border-color: #16f2b3;
}

.primary-button {
  padding: 0 13px;
  background: #16f2b3;
  border-color: #16f2b3;
  color: #04110d;
  font-weight: 900;
}

.primary-button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.work-area {
  min-height: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 12px;
  gap: 10px;
  background: #090d0f;
}

.session-tabs {
  display: flex;
  gap: 8px;
  overflow: auto;
  flex: 0 0 auto;
}

.session-tabs button {
  border: 1px solid #243033;
  background: #111719;
  color: #b9c9c4;
  border-radius: 8px;
  padding: 8px 10px;
  display: flex;
  align-items: center;
  gap: 7px;
  white-space: nowrap;
}

.terminal-grid {
  min-height: 0;
  flex: 1;
  display: grid;
  gap: 10px;
  grid-template-columns: minmax(0, 1fr);
}

.terminal-grid.mode-single,
.terminal-grid.mode-tabs,
.terminal-grid.visible-0,
.terminal-grid.visible-1 {
  grid-template-columns: minmax(0, 1fr);
}

.terminal-grid.mode-double.visible-2,
.terminal-grid.mode-triple.visible-2 {
  grid-template-columns: repeat(2, minmax(360px, 1fr));
}

.terminal-grid.mode-triple.visible-3 {
  grid-template-columns: repeat(2, minmax(360px, 1fr));
  grid-template-rows: minmax(0, 1.35fr) minmax(220px, 0.65fr);
}

.terminal-grid.mode-triple.visible-3 .terminal-panel.active {
  grid-column: 1/-1;
}

.terminal-panel {
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: #060809;
  border: 1px solid #1c2629;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 18px 36px rgba(0, 0, 0, 0.24);
}

.terminal-panel.active {
  order: -1;
  border-color: #16f2b3;
  box-shadow: 0 0 0 1px rgba(22, 242, 179, 0.22), 0 18px 36px rgba(0, 0, 0, 0.28);
}

.terminal-head {
  min-height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 10px;
  background: #101618;
  border-bottom: 1px solid #1f2a2d;
  color: #e7f4ef;
}

.terminal-meta {
  min-width: 0;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  column-gap: 8px;
  align-items: center;
}

.terminal-meta small {
  grid-column: 2;
  color: #849791;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.terminal-tools span {
  font-size: 11px;
  color: #7f918c;
}

.terminal-tools .close {
  width: 26px;
  height: 26px;
  background: #161f21;
  color: #9fb0aa;
  border-color: #2b383b;
}

.terminal-frame {
  min-height: 0;
  flex: 1;
  padding: 8px;
  background: #050708;
}

.terminal-element {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.terminal-element .xterm {
  height: 100%;
}

.empty-panel {
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: #5f716d;
  background: #0b1012;
  border: 1px dashed #26383a;
  box-shadow: none;
}

.empty-panel i {
  font-size: 24px;
  color: #16f2b3;
}

.status-dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  display: inline-block;
  flex: 0 0 auto;
}

.connected {
  background: #33e681;
  box-shadow: 0 0 10px rgba(51, 230, 129, 0.45);
}

.connecting {
  background: #f7c948;
  box-shadow: 0 0 10px rgba(247, 201, 72, 0.38);
}

.disconnected {
  background: #697a7d;
}

.error {
  background: #ff5c6c;
}

.current-context {
  display: grid;
  gap: 10px;
}

.current-context h3 {
  font-size: 16px;
  color: #f2fbf8;
}

.context-table {
  display: grid;
  gap: 8px;
  margin-top: 4px;
}

.context-row {
  border: 1px solid #202a2d;
  background: #12181a;
  border-radius: 8px;
  padding: 9px;
  display: grid;
  gap: 4px;
}

.context-row span {
  font-size: 11px;
  color: #7f918c;
}

.context-row strong {
  min-width: 0;
  color: #e8f5f0;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.empty-copy {
  font-size: 12px;
  color: #7f918c;
  padding: 8px 2px;
}

@media (max-width: 1100px) {
  :host,
  .workspace-shell {
    min-height: 100vh;
  }
  .workspace-shell {
    grid-template-columns: 228px minmax(0, 1fr);
  }
  .command-dock {
    display: none;
  }
  .terminal-grid.mode-triple {
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: none;
  }
  .terminal-grid.mode-double.visible-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .terminal-grid.mode-triple.visible-3 .terminal-panel.active {
    grid-column: auto;
  }
}
@media (max-width: 760px) {
  .workspace-shell {
    display: flex;
    flex-direction: column;
  }
  .preset-sidebar {
    max-height: 230px;
    border-right: 0;
    border-bottom: 1px solid #20292c;
    overflow: auto;
  }
  .topbar {
    height: auto;
    align-items: flex-start;
    flex-wrap: wrap;
  }
  .status-summary {
    display: none;
  }
  .work-area {
    padding: 8px;
  }
  .terminal-grid.mode-double,
  .terminal-grid.mode-triple {
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: none;
  }
  .terminal-grid.mode-triple.visible-3 .terminal-panel.active {
    grid-column: auto;
  }
  .terminal-head {
    align-items: flex-start;
  }
  .primary-button span {
    display: none;
  }
}`],
})
export class PageHomeComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChildren('terminalHost') public terminalHosts!: QueryList<ElementRef<HTMLDivElement>>;

    public readonly workspaceName = 'ShellDeck 로컬 터미널';
    public readonly maxSessions = 6;
    public layoutMode: LayoutMode = 'single';
    public selectedPresetId = 'local-terminal';
    public activeSessionId = '';
    public sessions: TerminalSession[] = [];
    private readonly displayUser = 'kimbomi';
    private readonly displayHost = 'bomiui-MacStudio';

    public presets: ServerPreset[] = [
        {
            id: 'local-terminal',
            name: '로컬 터미널',
            hostAlias: 'bomiui-MacStudio',
            sshUser: 'kimbomi',
            workdir: '~',
            color: '#3b82f6'
        }
    ];

    private timers: number[] = [];
    private sessionSequence = 0;
    private initialSessionsCreated = false;
    private readonly resizeHandler = () => this.fitVisibleTerminals();

    constructor(@Inject( Service) public service: Service,@Inject( ChangeDetectorRef)  public ref: ChangeDetectorRef) { }

    public async ngOnInit() {
        this.createInitialSessions();
        await this.initService();
        await this.renderView();
        this.schedule(() => this.mountVisibleTerminals(), 0);
    }

    public ngAfterViewInit() {
        this.terminalHosts.changes.subscribe(() => this.mountVisibleTerminals());
        window.addEventListener('resize', this.resizeHandler);
        this.schedule(() => this.mountVisibleTerminals(), 0);
    }

    public ngOnDestroy() {
        window.removeEventListener('resize', this.resizeHandler);
        this.timers.forEach((timer) => window.clearTimeout(timer));
        this.sessions.forEach((session) => {
            this.closeBackendSession(session);
            this.disposeTerminal(session);
        });
    }

    public get selectedPreset(): ServerPreset {
        return this.presets.find((preset) => preset.id === this.selectedPresetId) || this.presets[0];
    }

    public get activeSession(): TerminalSession | undefined {
        return this.sessions.find((session) => session.id === this.activeSessionId);
    }

    public get currentIdentity(): string {
        const session = this.activeSession;
        const preset = this.selectedPreset;
        return `${session?.sshUser || preset.sshUser}@${session?.hostAlias || preset.hostAlias} · ${session?.workdir || preset.workdir}`;
    }

    public get connectedCount(): number {
        return this.sessions.filter((session) => session.status === 'connected').length;
    }

    public get pendingCount(): number {
        return this.sessions.filter((session) => session.status === 'connecting').length;
    }

    public get visibleSessions(): TerminalSession[] {
        if (this.layoutMode === 'tabs') {
            return this.activeSession ? [this.activeSession] : [];
        }
        const limit = this.layoutLimit;
        if (this.sessions.length <= limit) return this.sessions;

        const activeIndex = Math.max(0, this.sessions.findIndex((session) => session.id === this.activeSessionId));
        const start = Math.min(Math.max(activeIndex - limit + 1, 0), this.sessions.length - limit);
        return this.sessions.slice(start, start + limit);
    }

    public get emptySlots(): number[] {
        if (this.sessions.length > 0) return [];
        return [0];
    }

    public get workspaceGridClass(): string {
        const visibleCount = this.visibleSessions.length + this.emptySlots.length;
        return `mode-${this.layoutMode} visible-${visibleCount}`;
    }

    private get layoutLimit(): number {
        if (this.layoutMode === 'single') return 1;
        if (this.layoutMode === 'double') return 2;
        return 3;
    }

    public trackBySession(_index: number, session: TerminalSession): string {
        return session.id;
    }

    public statusClass(status: SessionStatus): string {
        return status;
    }

    public statusLabel(status?: SessionStatus): string {
        if (status === 'connected') return '연결됨';
        if (status === 'connecting') return '연결 중';
        if (status === 'disconnected') return '종료됨';
        if (status === 'error') return '오류';
        return '세션 없음';
    }

    public formatClock(date: Date): string {
        return date.toLocaleTimeString('ko-KR', { hour: '2-digit', minute: '2-digit' });
    }

    public async selectPreset(presetId: string) {
        this.selectedPresetId = presetId;
        await this.renderView();
    }

    public async setLayout(mode: LayoutMode) {
        this.layoutMode = mode;
        await this.renderView();
        this.schedule(() => this.mountVisibleTerminals(), 0);
    }

    public async openSelectedPreset() {
        if (this.sessions.length >= this.maxSessions) return;
        this.createSession();
        await this.renderView();
        this.schedule(() => this.mountVisibleTerminals(), 0);
    }

    public async focusSession(sessionId: string) {
        const session = this.sessions.find((item) => item.id === sessionId);
        if (!session) return;
        this.activeSessionId = sessionId;
        this.selectedPresetId = session.presetId;
        await this.renderView();
        this.schedule(() => {
            this.mountVisibleTerminals();
            session.terminal?.focus();
        }, 0);
    }

    public async closeSession(sessionId: string, event?: Event) {
        event?.stopPropagation();
        const index = this.sessions.findIndex((item) => item.id === sessionId);
        if (index < 0) return;

        const session = this.sessions[index];
        session.status = 'disconnected';
        this.closeBackendSession(session);
        this.disposeTerminal(session);
        this.sessions = this.sessions.filter((item) => item.id !== sessionId);

        if (this.activeSessionId === sessionId) {
            const next = this.sessions[Math.min(index, this.sessions.length - 1)];
            this.activeSessionId = next?.id || '';
        }

        await this.renderView();
        this.schedule(() => this.mountVisibleTerminals(), 0);
    }

    private createSession(): TerminalSession {
        const preset = this.selectedPreset;
        const sequence = ++this.sessionSequence;
        const session: TerminalSession = {
            id: `${preset.id}-${Date.now()}-${sequence}`,
            roomId: this.createRoomId(sequence),
            title: sequence === 1 ? preset.name : `${preset.name} #${sequence}`,
            sequence,
            presetId: preset.id,
            hostAlias: preset.hostAlias,
            sshUser: preset.sshUser,
            workdir: preset.workdir,
            status: 'connecting',
            startedAt: new Date(),
            lastActiveAt: new Date(),
            outputBuffer: [],
            commandBuffer: '',
            closing: false,
            initializing: false,
            initMarker: '',
            initOutput: ''
        };

        this.sessions = [...this.sessions, session];
        this.activeSessionId = session.id;
        this.selectedPresetId = preset.id;
        this.bootSession(session);
        return session;
    }

    private createInitialSessions() {
        if (this.initialSessionsCreated) return;
        this.initialSessionsCreated = true;
        this.createSession();
    }

    private bootSession(session: TerminalSession) {
        this.schedule(() => {
            if (!this.hasSession(session.id)) return;
            this.mountVisibleTerminals();
        }, 0);
    }

    private createRoomId(sequence: number): string {
        const random = Math.random().toString(36).slice(2, 10);
        return `shell-${Date.now()}-${sequence}-${random}`;
    }

    private trackTerminalInput(session: TerminalSession, input: string) {
        if (!input || session.initializing) return;

        for (const char of Array.from(input)) {
            if (char === '\r' || char === '\n') {
                this.handleSubmittedCommand(session, session.commandBuffer.trim());
                session.commandBuffer = '';
                continue;
            }

            if (char === '\u007F') {
                session.commandBuffer = session.commandBuffer.slice(0, -1);
                continue;
            }

            if (char === '\u0003') {
                session.commandBuffer = '';
                continue;
            }

            if (char >= ' ') {
                session.commandBuffer += char;
            }
        }
    }

    private handleSubmittedCommand(session: TerminalSession, command: string) {
        if (!command) return;

        const sshTarget = this.parseSshTarget(command);
        if (sshTarget?.host) {
            session.remoteHost = sshTarget.host;
            session.title = sshTarget.host;
            session.hostAlias = sshTarget.host;
            session.sshUser = sshTarget.user || session.sshUser;
            session.workdir = '~';
            void this.renderView();
            return;
        }

        if (command === 'exit' && session.remoteHost) {
            session.remoteHost = undefined;
            this.applyDisplayIdentity(session);
            session.title = this.defaultSessionTitle(session);
            void this.renderView();
        }
    }

    private parseSshTarget(command: string): { user?: string; host: string } | null {
        const parts = command.split(/\s+/).filter(Boolean);
        if (parts[0] !== 'ssh') return null;

        const optionsWithValue = new Set(['-b', '-c', '-D', '-E', '-F', '-i', '-J', '-L', '-l', '-m', '-O', '-o', '-p', '-Q', '-R', '-S', '-W', '-w']);
        for (let index = 1; index < parts.length; index += 1) {
            const part = parts[index];
            if (!part) continue;

            if (part.startsWith('-')) {
                if (optionsWithValue.has(part)) index += 1;
                continue;
            }

            const target = part.replace(/^ssh:\/\//, '').replace(/\/$/, '');
            const [user, hostPart] = target.includes('@') ? target.split('@') : ['', target];
            const host = hostPart.replace(/^\[/, '').replace(/\]$/, '').replace(/:\d+$/, '');
            if (!host) return null;
            return { user: user || undefined, host };
        }

        return null;
    }

    private defaultSessionTitle(session: TerminalSession): string {
        const preset = this.presets.find((item) => item.id === session.presetId) || this.presets[0];
        return session.sequence === 1 ? preset.name : `${preset.name} #${session.sequence}`;
    }

    private mountVisibleTerminals() {
        if (!this.terminalHosts) return;
        const hosts = this.terminalHosts.toArray();
        const visibleIds = hosts.map((host) => host.nativeElement.dataset['sessionId'] || '');

        this.sessions.forEach((session) => {
            if (!visibleIds.includes(session.id)) this.disposeTerminal(session);
        });

        hosts.forEach((host) => {
            const sessionId = host.nativeElement.dataset['sessionId'];
            const session = this.sessions.find((item) => item.id === sessionId);
            if (!session) return;

            if (session.terminal && session.hostElement === host.nativeElement) {
                this.fitTerminal(session);
                this.ensureSocket(session);
                return;
            }

            this.disposeTerminal(session);
            const terminal = new Terminal({
                cursorBlink: true,
                macOptionIsMeta: true,
                fontFamily: 'SFMono-Regular, Consolas, Liberation Mono, monospace',
                fontSize: 13,
                lineHeight: 1.25,
                scrollback: 4000,
                theme: {
                    background: '#0b0f12',
                    foreground: '#d7e1e8',
                    cursor: '#f7c948',
                    black: '#0b0f12',
                    blue: '#60a5fa',
                    cyan: '#2dd4bf',
                    green: '#7dd56f',
                    magenta: '#c084fc',
                    red: '#fb7185',
                    white: '#edf2f7',
                    yellow: '#facc15'
                }
            });
            const fit = new FitAddon();
            terminal.loadAddon(fit);
            terminal.loadAddon(new WebLinksAddon());
            terminal.open(host.nativeElement);
            terminal.write(session.outputBuffer.join(''));
            terminal.onData((input) => {
                this.trackTerminalInput(session, input);
                this.emitSession(session, 'ptyinput', { input });
            });
            terminal.onResize(({ cols, rows }) => this.emitSession(session, 'resize', { cols, rows }));
            session.terminal = terminal;
            session.fit = fit;
            session.hostElement = host.nativeElement;
            this.fitTerminal(session);
            this.ensureSocket(session);
            if (session.id === this.activeSessionId) terminal.focus();
        });
    }

    private ensureSocket(session: TerminalSession, mode: SocketMode = 'app') {
        if (session.socket || session.closing) return;

        try {
            const socket = this.createSocket(mode);
            session.socket = socket;
            session.socketMode = mode;

            socket.on('connect', () => {
                if (!this.hasSession(session.id)) return;
                session.status = 'connecting';
                this.applyDisplayIdentity(session);
                this.emitSession(session, 'join');
                this.emitSession(session, 'create', this.terminalSize(session));
                this.startShellBootstrap(session);
                if (session.socketMode === 'ide') {
                    session.status = 'connected';
                }
                void this.renderView();
            });

            socket.on('ready', (data: any = {}) => {
                if (!this.hasSession(session.id)) return;
                this.applyTerminalIdentity(session, data);
                this.applyDisplayIdentity(session);
                session.status = 'connected';
                void this.renderView();
            });

            socket.on('ptyoutput', (data: any = {}) => {
                if (!this.hasSession(session.id)) return;
                this.handlePtyOutput(session, data.output || '');
            });

            socket.on('exit', (data: any = {}) => {
                if (!this.hasSession(session.id)) return;
                const message = data.message || '';
                if (message) this.write(session, `\r\n${message}\r\n`);
                session.status = session.closing ? 'disconnected' : 'disconnected';
                void this.renderView();
            });

            socket.on('disconnect', () => {
                if (!this.hasSession(session.id) || session.closing) return;
                session.status = 'disconnected';
                session.socket = undefined;
                session.socketMode = undefined;
                void this.renderView();
            });

            socket.on('connect_error', (error: any) => {
                if (!this.hasSession(session.id)) return;
                if (session.socketMode === 'app') {
                    this.detachSocket(session);
                    this.ensureSocket(session, 'ide');
                    return;
                }

                session.status = 'error';
                const message = error?.message ? ` (${error.message})` : '';
                this.write(session, `\r\nShellDeck: 로컬 터미널 소켓 연결 실패${message}\r\n`);
                void this.renderView();
            });
        } catch (_error) {
            session.status = 'error';
            this.write(session, '\r\nShellDeck: 로컬 터미널 소켓을 만들 수 없습니다.\r\n');
            void this.renderView();
        }
    }

    private createSocket(mode: SocketMode): any {
        if (mode === 'ide') {
            return io('/wiz/ide/app/xterm.app.term', { reconnection: false, timeout: 2500 });
        }

        return io(this.appSocketNamespace(), { reconnection: false, timeout: 2500 });
    }

    private appSocketNamespace(): string {
        const project = typeof wiz?.project === 'function' ? wiz.project() : 'main';
        return `/wiz/app/${project}/page.home`;
    }

    private startShellBootstrap(session: TerminalSession) {
        session.initializing = true;
        session.initOutput = '';
        session.initMarker = `__SHELLDECK_READY_${session.roomId}__`;

        this.emitSession(session, 'ptyinput', { input: 'stty -echo\r' });
        this.schedule(() => {
            if (!this.hasSession(session.id) || session.closing) return;
            this.emitSession(session, 'ptyinput', { input: this.shellBootstrapCommand(session) });
        }, 140);

        this.schedule(() => {
            if (!this.hasSession(session.id) || !session.initializing) return;
            session.initializing = false;
            const buffered = session.initOutput;
            session.initOutput = '';
            if (buffered) this.write(session, buffered);
        }, 3000);
    }

    private shellBootstrapCommand(session: TerminalSession): string {
        const bashPrompt = `${this.displayUser}@${this.displayHost} \\w % `;
        const zshPrompt = `${this.displayUser}@${this.displayHost} %~ %% `;
        return [
            `export PROMPT_COMMAND=''`,
            `export PS1='${bashPrompt}'`,
            `export PROMPT='${zshPrompt}'`,
            'cd ~',
            `printf '\\r\\n${this.toPrintfOctal(session.initMarker)}\\r\\n'`,
            'stty echo'
        ].join('\r') + '\r';
    }

    private toPrintfOctal(value: string): string {
        return Array.from(value)
            .map((char) => `\\${char.charCodeAt(0).toString(8).padStart(3, '0')}`)
            .join('');
    }

    private handlePtyOutput(session: TerminalSession, output: string) {
        if (!output) return;
        if (!session.initializing) {
            this.write(session, output);
            return;
        }

        session.initOutput += output;
        const markerIndex = session.initOutput.indexOf(session.initMarker);
        if (markerIndex < 0) return;

        const afterMarker = this.cleanBootstrapRemainder(
            session.initOutput.slice(markerIndex + session.initMarker.length).replace(/^[\r\n]+/, '')
        );
        session.initializing = false;
        session.initOutput = '';
        session.outputBuffer = [];
        session.terminal?.clear();
        if (afterMarker) this.write(session, afterMarker);
    }

    private cleanBootstrapRemainder(output: string): string {
        const promptStart = `${this.displayUser}@${this.displayHost}`;
        const lastPromptIndex = output.lastIndexOf(promptStart);
        if (lastPromptIndex >= 0) return output.slice(lastPromptIndex);
        if (output.trim().length > 0) return output;
        return `${promptStart} ~ % `;
    }

    private emitSession(session: TerminalSession, channel: string, data: Record<string, any> = {}) {
        if (!session.socket || session.closing) return;
        session.socket.emit(channel, { ...data, namespace: session.roomId });
    }

    private terminalSize(session: TerminalSession): { cols: number; rows: number } {
        return {
            cols: session.terminal?.cols || 80,
            rows: session.terminal?.rows || 24
        };
    }

    private applyTerminalIdentity(session: TerminalSession, data: any) {
        session.sshUser = data.user || session.sshUser;
        session.hostAlias = data.host || session.hostAlias;
        session.workdir = data.workdir || session.workdir;
        this.syncPresetIdentity(session);
    }

    private applyDisplayIdentity(session: TerminalSession) {
        session.sshUser = this.displayUser;
        session.hostAlias = this.displayHost;
        session.workdir = '~';
        this.syncPresetIdentity(session);
    }

    private syncPresetIdentity(session: TerminalSession) {
        this.presets = this.presets.map((preset) => {
            if (preset.id !== session.presetId) return preset;
            return {
                ...preset,
                sshUser: session.sshUser,
                hostAlias: session.hostAlias,
                workdir: session.workdir
            };
        });
    }

    private write(session: TerminalSession, chunk: string) {
        if (!chunk) return;
        session.lastActiveAt = new Date();
        session.outputBuffer.push(chunk);
        if (session.outputBuffer.length > 1200) {
            session.outputBuffer = session.outputBuffer.slice(-1200);
        }
        session.terminal?.write(chunk);
    }

    private fitVisibleTerminals() {
        this.visibleSessions.forEach((session) => this.fitTerminal(session));
    }

    private fitTerminal(session: TerminalSession) {
        try {
            session.fit?.fit();
            session.terminal?.scrollToBottom();
            this.emitSession(session, 'resize', this.terminalSize(session));
        } catch (_error) { }
    }

    private disposeTerminal(session: TerminalSession) {
        session.terminal?.dispose();
        session.terminal = undefined;
        session.fit = undefined;
        session.hostElement = undefined;
    }

    private closeBackendSession(session: TerminalSession) {
        if (session.closing) return;
        this.emitSession(session, 'close');
        session.closing = true;
        this.detachSocket(session);
    }

    private detachSocket(session: TerminalSession) {
        try {
            session.socket?.removeAllListeners?.();
            session.socket?.close?.();
        } catch (_error) { }
        session.socket = undefined;
        session.socketMode = undefined;
    }

    private hasSession(sessionId: string): boolean {
        return this.sessions.some((session) => session.id === sessionId);
    }

    private async initService() {
        try {
            if ((this.service as any)?.inited) {
                await this.service.init();
                return;
            }
            await this.service.init(this);
        } catch (_error) { }
    }

    private async renderView() {
        try {
            this.ref.detectChanges();
        } catch (_error) { }
    }

    private schedule(callback: () => void, delay: number): number {
        const timer = window.setTimeout(() => {
            this.timers = this.timers.filter((item) => item !== timer);
            callback();
        }, delay);
        this.timers.push(timer);
        return timer;
    }
}

export default PageHomeComponent;